"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.INTRO_TEXT_SKELETON = void 0;
const INTRO_TEXT_SKELETON = exports.INTRO_TEXT_SKELETON = 'intro-text-skeleton';
